import { lazy } from 'react';
import SuspenseWrapper from '@/components/SuspenseWrapper.tsx';
import DeferredBoot from '@/components/DeferredBoot.tsx';
import { useRouter } from '@tanstack/react-router';
import ErrorBoundary from '@/components/ErrorBoundary';

import Header from '@/components/Header';

const Footer = lazy(() => import('@/components/Footer'));
const Toaster = lazy(() => import('react-hot-toast').then((m) => ({ default: m.Toaster })));

export default function CompactLayout({
  children,
  feedbackButton = null,
  feedbackOverlay = null,
}: {
  children: React.ReactNode;
  feedbackButton?: React.ReactNode;
  feedbackOverlay?: React.ReactNode;
}) {
  const router = useRouter();
  const pathname = router.state.location?.pathname || '';

  return (
    <div className="flex flex-col min-h-screen bg-primary-light">
      <SuspenseWrapper fallbackClassName="h-0 w-0 opacity-0">{feedbackOverlay}</SuspenseWrapper>
      <DeferredBoot>
        <SuspenseWrapper fallbackClassName="h-0 w-0 opacity-0">
          <Toaster position="top-center" reverseOrder={false} />
        </SuspenseWrapper>
      </DeferredBoot>
      <Header feedbackButton={feedbackButton} />

      <main className="flex-1 flex flex-col w-full">
        <ErrorBoundary>
          <SuspenseWrapper fallbackClassName="flex-1 w-full bg-primary-light !rounded-none !animate-none">
            {children}
          </SuspenseWrapper>
        </ErrorBoundary>
      </main>

      {pathname === '/' && (
        <SuspenseWrapper fallbackClassName="h-40 w-full">
          <Footer />
        </SuspenseWrapper>
      )}
    </div>
  );
}
